// @flow

export default (date: Date | string) => {
  date = new Date(date);
  return date.getTime() + date.getTimezoneOffset() * 60 * -1000;
};
